import axios from "axios"
import { API_BASE_URL_2 } from "./varConstant"
import CryptoJS from 'crypto-js';

export const SECRET_KEY = CryptoJS.enc.Hex.parse('0123456789abcdef0123456789abcdef0123456789abcdef0123456789abcdef');

const fromBase64Url = (base64UrlString) => {
    let base64 = base64UrlString.replace(/-/g, '+').replace(/_/g, '/');
    // Pad the string with `=` to make its length a multiple of 4
    while (base64.length % 4) {
        base64 += '=';
    }
    return CryptoJS.enc.Base64.parse(base64);
};

export const GetShareBoxBreakDetails = async () => {
    const getQueryParam = (param) => new URLSearchParams(window.location.search).get(param);

    const cipher = getQueryParam('data');
    const ivBase64 = getQueryParam('iv');

    // Log for debugging
    console.log('Cipher from URL:', cipher);
    console.log('IV from URL:', ivBase64);

    if (!cipher || !ivBase64) {
        console.warn('Missing cipher or IV in URL query params');
        return null;
    }

    try {
        const iv = fromBase64Url(ivBase64);
        const ciphertext = fromBase64Url(cipher);
        const decryptedData = CryptoJS.AES.decrypt({ ciphertext }, SECRET_KEY, {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        const boxBreakId = decryptedData.toString(CryptoJS.enc.Utf8).trim(); // trim to remove whitespace

        if (!boxBreakId) {
            console.error('Decryption failed or boxBreakId is empty');
            return null;
        }

        const endpoint = `${API_BASE_URL_2}/xdeal/GetShareBoxBreakDetails`;
        const parameter = { box_break_id: boxBreakId };

        console.log('POST:', endpoint);
        console.log('Payload:', JSON.stringify(parameter, null, 2));

        const response = await axios.post(endpoint, parameter);

        if (!response?.data) {
            console.warn('No data returned from API');
            return null;
        }

        console.log('API Response:', JSON.stringify(response.data, null, 2));
        return response;
    } catch (error) {
        console.error('Error in GetShareBoxBreakDetails:', error);
        return null;
    }
};
